import { useState, useEffect } from 'react';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      id: 1,
      question: '利用するにはどのような手続きが必要ですか？',
      answer: 'まずはお電話またはお問い合わせフォームからご連絡ください。見学・相談の日程を調整させていただきます。その後、お住まいの市区町村で障害福祉サービス受給者証の申請を行っていただきます。受給者証が発行されましたら、利用契約を結び、サービスの利用を開始できます。',
    },
    {
      id: 2,
      question: '利用料金はどのくらいかかりますか？',
      answer: '障害福祉サービス受給者証をお持ちの方は、世帯収入に応じた自己負担額となります。多くの方が無料または低額でご利用いただけます。生活保護受給世帯や市町村民税非課税世帯の方は自己負担なし、市町村民税課税世帯の方は月額上限9,300円または37,200円となります。詳しくはお問い合わせください。',
    },
    {
      id: 3,
      question: 'どのような訓練プログラムがありますか？',
      answer: 'パソコン操作、事務作業、軽作業、コミュニケーションスキル、ビジネスマナーなど、多様なプログラムをご用意しています。一人ひとりの目標や適性に合わせて、個別支援計画を作成し、段階的にスキルアップできるようサポートします。',
    },
    {
      id: 4,
      question: '通所の頻度や時間は決まっていますか？',
      answer: 'ご本人の体調やペースに合わせて、週1日から週5日まで柔軟に対応しています。時間も午前のみ、午後のみ、または終日など、無理のない範囲で調整可能です。まずは短時間から始めて、徐々に通所日数や時間を増やしていくこともできます。',
    },
    {
      id: 5,
      question: '就職後のサポートはありますか？',
      answer: 'はい、就職後も定期的に職場訪問を行い、職場定着のためのサポートを継続します。職場での困りごとや悩みの相談、必要に応じて企業との調整なども行います。安心して長く働き続けられるよう、最長6ヶ月間のフォローアップを実施しています。',
    },
    {
      id: 6,
      question: '見学や体験利用はできますか？',
      answer: 'もちろん可能です。事前にご予約いただければ、いつでも施設見学を受け付けています。また、実際の訓練プログラムを体験していただくこともできます。雰囲気を感じていただき、納得してからご利用を開始していただけます。お気軽にお問い合わせください。',
    },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Add FAQ Schema.org JSON-LD
  useEffect(() => {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    let scriptTag = document.querySelector('script[data-schema="faq"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      scriptTag.setAttribute('data-schema', 'faq');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(faqSchema);

    return () => {
      const tag = document.querySelector('script[data-schema="faq"]');
      if (tag) {
        tag.remove();
      }
    };
  }, []);

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-bg-ivory">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <p className="text-primary text-sm font-medium tracking-wider mb-3">（よくある質問）</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-text-dark">
            FAQ
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl shadow-md overflow-hidden transition-shadow hover:shadow-lg"
            >
              {/* Question */}
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="font-bold text-text-dark text-base sm:text-lg pr-4">
                  Q. {faq.question}
                </span>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-primary flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 bg-bg-beige">
                  <p className="text-text-medium leading-relaxed">A. {faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
